// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__3DhbR","spinner":"PageLoading_spinner__3lNrv","spin":"PageLoading_spin__1PWPG"};